"use client";

import {
  Box,
  Stack,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import { useState } from "react";
import { useContextStore } from "@/src/stores/useContextStore";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { cn } from "@/src/shared/utils/mergeTwClasses";

import { TouristOrderInfoModal } from "./TouristOrderInfoModal";
import { TouristOrderField } from "./TouristOrderField";
import { TourismOrderField } from "../lib/types";
import { useUpdateField } from "@/src/hooks/useFieldDebouncedCallback";
import { FlowCodes } from "@/src/components/pages/StepPage/components/apiCalls/contants";

export const touristInfoFields: TourismOrderField[] = [
  {
    label: "Прізвище та ім’я (латиницею)",
    names: ["tourist_lastNameLatin", "tourist_firstNameLatin"],
    modalName: "Прізвище та ім'я (латиницею)",
    modalFiedls: [
      {
        name: "tourist_lastNameLatin",
        label: "Прізвище",
        pattern: "^[a-zA-Z'][a-zA-Z'`\\- ]*[a-zA-Z'\\s]$",
        required: true,
      },
      {
        name: "tourist_firstNameLatin",
        label: "ім’я",
        pattern: "^[a-zA-Z'][a-zA-Z'`\\- ]*[a-zA-Z'\\s]$",
        required: true,
      },
    ],
  },
  { label: "Дата народження", names: ["tourist_birthDate"] },
  { label: "Ідентифікаційний номер", names: ["tourist_identCode"] },
  {
    label: "Закордонний паспорт",
    names: ["tourist_foreignPassportNumber"],
    modalName: "Документ",
    modalFiedls: [
      {
        name: "tourist_foreignPassportNumber",
        label: "Закордонний паспорт:",
        pattern: "^[A-Za-z]{2}\\d{6}$",
        minLength: 8,
        maskType: "passportSerie",
        required: true,
      },
    ],
  },
];

// export const insurerInfoFields: TourismOrderField[] = [
//     { label: "Прізвище та ім’я(латиницею)", names: ["tourist_lastNameLatin", "tourist_firstNameLatin"] },
//     { label: "Дата народження", names: ["tourist_birthDate"] },
//     { label: "Ідентифікаційний номер", names: ["tourist_identCode"] },
//     { label: "Номер телефону", names: ["phoneNumber"] },
//     { label: "Електронна пошта", names: ["email"] },
//     { label: "Документ", names: ["documentType", "foreignPassportNumber"] },
// ];

export const TouristsOrderInfo = ({
  name,
  index,
}: {
  name: string;
  index: number;
}) => {
  const updateField = useUpdateField();

  const updateVariableValue = useContextStore(
    (state) => state.updateVariableValue,
  );

  const [selectedField, setSelectedField] = useState<{
    item: TourismOrderField;
    name: string;
  } | null>(null);

  const { getValues, setValue } = useFormContext();
  const modalForm = useForm({ mode: "all" });

  const handleEditClick = (item: TourismOrderField) => {
    modalForm.reset(getValues()[name][index]);
    setSelectedField({ item, name: `${name}.${index}` });
  };

  const handleSaveClick = modalForm.handleSubmit((formData) => {
    selectedField?.item?.names?.forEach((fieldName) => {
      setValue(`${name}.${index}.${fieldName}`, formData[fieldName], {
        shouldDirty: true,
      });
    });

    const newTourists = getValues(name);
    updateVariableValue(name, newTourists);
    updateField(name, newTourists);

    handleModalClose();
  });

  const handleModalClose = () => {
    setSelectedField(null);
  };

  const isInsurer = getValues(name)?.[index]?.isInsurerTourist;

  if (isInsurer) {
    return null;
  }

  const isVisaCentre = getValues("flowCode") === FlowCodes.VZK_VISA_CENTER;

  return (
    <Box className={cn("w-full bg-white-gray p-4")}>
      <Stack className="flex flex-col items-start gap-4">
        <Typography
          variant="body1"
          component="h3"
          className="text-lg font-semibold"
        >
          {isVisaCentre ? "Дані застрахованого" : `Турист ${index + 1}`}
        </Typography>
        <List className="flex flex-col gap-3 max-md:w-full md:grid md:grid-cols-[max-content_auto]">
          {touristInfoFields?.map((item) => (
            <ListItem
              className="relative contents gap-2 max-md:justify-between max-md:flex-center-row"
              key={item.label ?? index}
            >
              <TouristOrderField
                item={item}
                name={name}
                index={index}
                handleEditClick={handleEditClick}
              />
              {/* {!!item.modalFiedls?.length && (
                <IconButton
                  className="flex p-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditClick(item);
                  }}
                >
                  <WebShopIcon name="pencil" fill={"#009DDE"} />
                </IconButton>
              )} */}
            </ListItem>
          ))}
          <FormProvider {...modalForm}>
            <TouristOrderInfoModal
              open={!!selectedField}
              fields={selectedField?.item?.modalFiedls || []}
              name={selectedField?.name || ""}
              onSubmit={handleSaveClick}
              onClose={handleModalClose}
              title={selectedField?.item?.modalName}
            />
          </FormProvider>
        </List>
      </Stack>
    </Box>
  );
};
